var _path, _path2, _path3, _path4;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgEmoji3(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.8771 31.7542C24.6458 31.7542 31.7542 24.6458 31.7542 15.8771C31.7542 7.10842 24.6458 0 15.8771 0C7.10842 0 0 7.10842 0 15.8771C0 24.6458 7.10842 31.7542 15.8771 31.7542Z",
    fill: "#FFDD67"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M9.79084 15.6654C11.2523 15.6654 12.437 14.4807 12.437 13.0192C12.437 11.5578 11.2523 10.373 9.79084 10.373C8.32939 10.373 7.14465 11.5578 7.14465 13.0192C7.14465 14.4807 8.32939 15.6654 9.79084 15.6654Z",
    fill: "#664E27"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M21.9633 15.6654C23.4248 15.6654 24.6095 14.4807 24.6095 13.0192C24.6095 11.5578 23.4248 10.373 21.9633 10.373C20.5019 10.373 19.3171 11.5578 19.3171 13.0192C19.3171 14.4807 20.5019 15.6654 21.9633 15.6654Z",
    fill: "#664E27"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M22.5455 20.2699C18.2586 23.2865 13.4955 23.2336 9.2087 20.2699C8.67946 19.8994 8.25607 20.5345 8.57361 21.1166C9.8967 23.2336 12.49 25.1918 15.8771 25.1918C19.2642 25.1918 21.8575 23.2865 23.1805 21.1166C23.4981 20.5345 23.0747 19.8994 22.5455 20.2699Z",
    fill: "#664E27"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmoji3);
export default __webpack_public_path__ + "static/media/emoji3.d4a98ece30fad566ce835c618ed05f8a.svg";
export { ForwardRef as ReactComponent };